import { Flex, FlexProps } from "@mantine/core";
import { ShipmentCargo } from "types/Shipment";
import { roundLoadingMeter } from "utils/loadingMeter";

interface ShipmentActivityInfoProps extends FlexProps {
  cargo: ShipmentCargo;
}

const ShortActivityInfo: React.FC<ShipmentActivityInfoProps> = ({
  cargo,
  gap = 4,
  align = "center",
  ...flexProps
}) => {
  const loadingMeter = roundLoadingMeter(cargo?.loadingMeter);

  return (
    <Flex gap={gap} align={align} {...flexProps}>
      <Flex gap={4}>
        <span>{cargo?.unitAmount}</span>

        <span>{cargo?.unit?.code}</span>
      </Flex>

      <Flex gap={4}>
        <span>{loadingMeter}</span>
        <span>ldm</span>
      </Flex>
    </Flex>
  );
};

export default ShortActivityInfo;
